import FloatingCompoundTable from "@/components/FloatingCompoundTable.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import ProductTableGroupBy from "@/components/search_funnel/ProductTableGroupBy.vue";
import ProductTableTotal from "@/components/search_funnel/ProductTableTotal.vue";
import FlexRow from "@/components/FlexRow.vue";
import WrapWithArrow from "@/components/tableElements/WrapWithArrow.vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import BlockBarWithValue from "@/components/tableElements/BlockBarWithValue.vue";
import BoxAndBarWithValue from "@/components/tableElements/BoxAndBarWithValue.vue";
import BlockStyledBar from "@/components/tableElements/BlockStyledBar.vue";
import LayerBars from "@/components/tableElements/LayerBars.vue";
import VariableStyledBar from "@/components/tableElements/VariableStyledBar.vue";
import WrapWithAlertIcon from "@/components/WrapWithAlertIcon.vue";
import ViewExportDropdown from "@/components/ViewExportDropdown.vue";
import AppIconGroup from "@/components/AppIconGroup";
import FilterDivider from "@/components/new-filters/FilterDivider.vue";
import TargetingTypeValue from "@/components/tableElements/TargetingTypeValue.vue";
import { mapState, mapGetters } from "vuex";
import { capitalize } from "vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange } from "@/utils/transformers";
import { EVENTS, TREND_DIRECTION_TYPE, KPI_DIRECTION_TYPE, DAYS_INVENTORY_HEATMAP_COLORS, ORGANIC_CVR_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, COLORS, ANALYTICS_CSV_PAGE_SIZE, CPC_DECILE_COLORS, CVR_HEATMAP_COLORS, PROFIT_DECILE_COLORS, PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS, FLOATING_COMPOUND_TABLE_STATES, GROUP_BY_TAB_ELEMENTS, TARGETING_TYPE_TYPES, PPC_EXTRA_FILTERS, HANDLE_ADD_FILTER_MODES, SEARCH_FUNNEL_CTR_HEATMAP_COLORS, SEARCH_FUNNEL_CVR_HEATMAP_COLORS, TARGETING_TYPE_SPLIT } from "@/utils/constants";
import { country_code_amz_sp_api_marketplace_ids, amz_sp_api_marketplace_ids_country_domains, country_code_amz_sp_api_marketplace_ids_flipped, amz_sp_api_marketplace_ids_country_domains_flipped } from "@/utils/countries";
import { SEARCHES_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_IMPRESSION_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_CLICK_FIELD, BRAND_PURCHASE_SHARE_FIELD, BRAND_PURCHASE_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD, SELLER_FIELD, MARKETPLACE_FIELD, PRODUCT_FIELD, KEYWORD_TYPE_FIELD, TARGETING_TYPE_FIELD, KEYWORD_FIELD, SEARCH_FUNNEL_CVR_FIELD, SEARCH_FUNNEL_CTR_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SELLER_NOTORIETY_FIELD } from "@/utils/table_fields";
import { HugValue, DateValue, RateChangeValue, CurrencyValue, NumberValue, BoxedValue, BarWithValue, PercentageValue, DottedValue, OverlapBarValue, EvolutionArrow, SegmentedBar, ImageElement, HashedNumberValue, DottedPositionBar, BarWithDifferenceFromMaxMarked, RangeBar, DotElement, TextValue, ValueElement, MarketplaceValue, ProductValue, BrandParentValue } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { processDate, formatLink, truncateString } from "@/utils";
import { HISTORY_PERIOD_TEXTS } from "../../utils/datepicker";
export default {
  name: "ProductTable",
  components: {
    FloatingCompoundTable,
    ProductTableGroupBy,
    ProductTableTotal,
    WrapWithPopover,
    HugValue,
    DateValue,
    RateChangeValue,
    CurrencyValue,
    NumberValue,
    BoxedValue,
    BarWithValue,
    PercentageValue,
    DottedValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    EvolutionArrow,
    SegmentedBar,
    ImageElement,
    HashedNumberValue,
    DottedPositionBar,
    BarWithDifferenceFromMaxMarked,
    RangeBar,
    DotElement,
    TextValue,
    ValueElement,
    MarketplaceValue,
    ProductValue,
    BrandParentValue,
    TargetingTypeValue,
    WrapWithArrow,
    LayerBars,
    VariableStyledBar
  },
  emits: ["refresh", "changeDate", "refreshOtherKpis", "restoreEvolutionTable"],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    secondaryFilterInitializers: {
      type: Object
    }
  },
  mixins: [LiteTableMixin, DownloadMixin, TasksMixin],
  data() {
    return {
      EVENTS,
      TREND_DIRECTION_TYPE,
      KPI_DIRECTION_TYPE,
      DAYS_INVENTORY_HEATMAP_COLORS,
      ORGANIC_CVR_HEATMAP_COLORS,
      BUYBOX_HEATMAP_COLORS,
      COLORS,
      CPC_DECILE_COLORS,
      CVR_HEATMAP_COLORS,
      PROFIT_REVENUE_PERCENTAGE_DECILE_COLORS,
      HISTORY_PERIOD_TEXTS,
      TARGETING_TYPE_TYPES,
      SEARCH_FUNNEL_CTR_HEATMAP_COLORS,
      SEARCH_FUNNEL_CVR_HEATMAP_COLORS,
      country_code_amz_sp_api_marketplace_ids,
      amz_sp_api_marketplace_ids_country_domains,
      country_code_amz_sp_api_marketplace_ids_flipped,
      amz_sp_api_marketplace_ids_country_domains_flipped,
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_previous_year"
      },
      fieldsSources: {
        performance: {
          asin: [PRODUCT_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SELLER_NOTORIETY_FIELD, BRAND_IMPRESSION_FIELD, SEARCH_FUNNEL_CTR_FIELD, BRAND_CLICK_FIELD, SEARCH_FUNNEL_CVR_FIELD, BRAND_PURCHASE_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_PURCHASE_SHARE_FIELD],
          seller: [SELLER_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SELLER_NOTORIETY_FIELD, BRAND_IMPRESSION_FIELD, SEARCH_FUNNEL_CTR_FIELD, BRAND_CLICK_FIELD, SEARCH_FUNNEL_CVR_FIELD, BRAND_PURCHASE_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_PURCHASE_SHARE_FIELD],
          marketplace: [MARKETPLACE_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SELLER_NOTORIETY_FIELD, BRAND_IMPRESSION_FIELD, SEARCH_FUNNEL_CTR_FIELD, BRAND_CLICK_FIELD, SEARCH_FUNNEL_CVR_FIELD, BRAND_PURCHASE_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_PURCHASE_SHARE_FIELD],
          keyword: [KEYWORD_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SEARCHES_FIELD, BRAND_IMPRESSION_FIELD, SEARCH_FUNNEL_CTR_FIELD, BRAND_CLICK_FIELD, SEARCH_FUNNEL_CVR_FIELD, BRAND_PURCHASE_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_PURCHASE_SHARE_FIELD],
          keyword_type: [KEYWORD_TYPE_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SEARCHES_FIELD, BRAND_IMPRESSION_FIELD, SEARCH_FUNNEL_CTR_FIELD, BRAND_CLICK_FIELD, SEARCH_FUNNEL_CVR_FIELD, BRAND_PURCHASE_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_PURCHASE_SHARE_FIELD]
        },
        opportunities: {
          asin: [PRODUCT_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD],
          seller: [SELLER_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD],
          marketplace: [MARKETPLACE_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD],
          keyword: [KEYWORD_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD],
          keyword_type: [KEYWORD_TYPE_FIELD, SEARCH_FUNNEL_OPPRTUNITIES_SEARCHES_FIELD, SEARCH_FUNNEL_PURCHASES_SHARE_FIELD, SEARCH_FUNNEL_TOP_PRODUCT_FIELD, SEARCH_FUNNEL_SHARE_OF_VOICE_FIELD, SEARCH_FUNNEL_BEST_POSITION_FIELD, SEARCH_FUNNEL_SOV_SPONSORED_FIELD, SEARCH_FUNNEL_NUMBER_OF_IMPRESSIONS_PER_SEARCH_FIELD, SEARCH_FUNNEL_CLICK_SHARE_FIELD, SEARCH_FUNNEL_ESTMATED_OPPORTUNITY_FIELD]
        }
      },
      CLICK_TO_FILTER_OPTIONS: {
        asin: this.asinClickToFilter,
        seller: this.sellersClickToFilter,
        marketplace: this.marketplacesClickToFilter,
        keyword_type: this.searchQueryTypeClickToFilter,
        keyword: this.targetingsClickToFilter
      },
      CLICK_TO_CLEAR_FILTER_OPTIONS: {
        asin: this.asinClickToClearFilter,
        seller: this.sellersClickToClearFilter,
        marketplace: this.marketplacesClickToClearFilter,
        keyword_type: this.searchQueryTypeClickToClearFilter,
        keyword: this.targetingsClickToClearFilter
      },
      fieldKeySwitchMap: {
        'targeting_type': 'search_query_type',
        'purchases_share': 'purchase_share'
      }
    };
  },
  computed: {
    ...mapState({
      groupBy: state => state.search_funnel.product_table.group_by_text,
      productTable: state => state.search_funnel.product_table,
      currentTabValue: state => state.search_funnel.currentTabValue,
      periodCategory: state => state.search_funnel.periodCategory,
      currencyConfig: state => state.search_funnel.currencyConfig,
      products: state => state.search_funnel.products,
      sellers_filter: state => state.search_funnel.sellers_filter,
      marketplaces_filter: state => state.search_funnel.marketplaces_filter,
      targeting_types: state => state.search_funnel.targeting_types,
      targetings: state => state.search_funnel.targetings,
      competitor_parents: state => state.search_funnel.product_table.competitor_parents,
      period: state => state.search_funnel.period,
      accounts: state => state.account.list
    }),
    ...mapGetters(["searchFunnelSingleMarketplace", "getCountryFlag"]),
    filteredItems() {
      const rows = this.productTable[this.currentTabValue].data[this.groupBy]?.items;
      return rows;
    },
    total() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.total;
    },
    minMax() {
      //console.log('minMax', this.productTable[this.currentTabValue].data[this.groupBy]?.minMax);
      return this.productTable[this.currentTabValue].data[this.groupBy]?.minMax;
    },
    sort() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.sort;
    },
    maxCharCount() {
      return this.productTable[this.currentTabValue].data[this.groupBy]?.maxCharCount;
    },
    fields() {
      return this.fieldsSources[this.currentTabValue][this.groupBy];
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    },
    page: {
      set(val) {
        this.$store.dispatch("searchFunnelSetProductTablePage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.searchFunnelGetProductTablePage();
      }
    },
    perPage: {
      set(val) {
        this.$store.dispatch("searchFunnelSetProductTablePerPage", val);
        this.$emit("refresh");
      },
      get() {
        return this.$store.getters.searchFunnelGetProductTablePerPage();
      }
    },
    totalPages: {
      set(val) {
        this.$store.dispatch("searchFunnelSetProductTableTotalPages", val);
      },
      get() {
        return this.$store.getters.searchFunnelGetProductTableTotalPages();
      }
    },
    getTbodyTrClass() {
      return item => this.handleRowClass(item, this.filteredItems);
    },
    getThClass() {
      return field => {
        return [];
      };
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    formatLink,
    truncateString,
    handleDatePickerSubmit(date) {
      this.$emit("changeDate", date);
      this.$emit("restoreEvolutionTable");
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleTableState(state) {
      this.$store.dispatch("searchFunnelSetProductTableState", state);
    },
    handleGroupByRefresh() {
      this.$emit("refresh");
    },
    handleClicked() {
      window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    },
    handleHeadClick(fieldKey) {
      fieldKey = this.fieldKeySwitchMap[fieldKey] ?? fieldKey;
      const directionFlip = {
        asc: "desc",
        desc: "asc"
      };
      if (this.loading) return;
      const direction = directionFlip[this.sort[fieldKey]] ?? "desc";
      this.handleSort({
        sort: fieldKey,
        direction
      });
    },
    async asinClickToFilter(item) {
      // Set the `products` filter
      this.products.clear();
      this.products.apply();
      //console.log('keyword', keyword)
      this.marketplaces_filter._key = "sales_channel";
      let res = await this.products.asyncSearchAndSelect({
        keyword: [item.asin],
        args: {
          sellers: this.sellers_filter.filterValues,
          sales_channel: this.marketplaces_filter.filterValues
        },
        key: "asin"
      });
      if (!res) {
        return;
      }
      this.products.apply();
      await window.$bus.trigger(EVENTS.CLEAR_SEARCH_FUNNEL_MORE_FILTERS);
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_PRODUCTS_SUB_FILTERS);
      this.$emit("refreshOtherKpis");
    },
    async asinClickToClearFilter() {
      // Set the `product` filter
      await this.products.clearAfterAsyncSearch({
        args: {
          sellers: this.sellers_filter.filterValues,
          sales_channel: this.marketplaces_filter.filterValues
        }
      });
      await window.$bus.trigger(EVENTS.CLEAR_SEARCH_FUNNEL_MORE_FILTERS);
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_PRODUCTS_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async sellersClickToFilter(item) {
      // Set the `seller` filter
      this.sellers_filter.selectOnly({
        id: item.seller_id
      }, "id");
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_SELLERS_SUB_FILTERS);
      this.$emit("refreshOtherKpis");
    },
    async sellersClickToClearFilter() {
      // Set the `seller` filter
      this.sellers_filter.clear();
      this.sellers_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_SELLERS_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async marketplacesClickToFilter(item) {
      this.marketplaces_filter.selectOnly({
        sales_channel: item?.sales_channel
      }, "sales_channel");

      // Set the current group by to `product`
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_MARKETPLACES_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async marketplacesClickToClearFilter() {
      // Set the `marketplace` filter
      this.marketplaces_filter.clear();
      this.marketplaces_filter.apply();
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_MARKETPLACES_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async searchQueryTypeClickToFilter(item) {
      const searchQueryTypeMap = {
        "Non-Branded": "Non-branded",
        Branded: "Branded",
        Competitor: "Competitors",
        Discovery: "Discovery"
      };
      // await this.secondaryFilterInitializers[PPC_EXTRA_FILTERS.TARGETING_TYPE](); // This is to make sure that the filter is initialized before it's called.
      this.targeting_types.selectOnly({
        short_name: searchQueryTypeMap[item.search_query_type]
      }, "short_name");
      this.targeting_types.apply();
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_KEYWORD_TYPE_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async searchQueryTypeClickToClearFilter() {
      this.targeting_types.clear();
      this.targeting_types.apply();
      await window.$bus.trigger(EVENTS.REFRESH_SEARCH_FUNNEL_KEYWORD_TYPE_SUB_FILTERS);
      await this.$emit("refreshOtherKpis");
    },
    async targetingsClickToFilter(item) {
      // await this.secondaryFilterInitializers[PPC_EXTRA_FILTERS.TARGETING](); // This is to make sure that the filter is initialized before it's called.
      await this.clearAndRefresh({
        entity: this.targetings,
        filters: {
          sellers: this.sellers_filter.filterValues,
          sales_channel: this.marketplaces_filter.filterValues
        }
      });
      this.targetings.selectOnly({
        targeting: item?.search_query
      }, "targeting");
      this.targetings.apply();
      await this.$emit("refreshOtherKpis");
    },
    async targetingsClickToClearFilter() {
      await this.clearAndRefresh({
        entity: this.targetings,
        filters: {
          sellers: this.sellers_filter.filterValues,
          sales_channel: this.marketplaces_filter.filterValues
        },
        postActions: [() => this.$emit("refreshOtherKpis")]
      });
    },
    async handleBreakdownReset() {
      const clickToClearFilter = this.CLICK_TO_CLEAR_FILTER_OPTIONS[this.groupBy];
      await clickToClearFilter();
    },
    async handleBreakdownSelect(item) {
      const clickToFilter = this.CLICK_TO_FILTER_OPTIONS[this.groupBy];
      await clickToFilter(item);
    },
    async handleRowClick(item, _, event) {
      //console.log('handleRowClick', event)
      const performanceFloatingCompoundTable = this.$refs.performanceFloatingCompoundTable;
      if (performanceFloatingCompoundTable) {
        performanceFloatingCompoundTable.handleNormalize();
      }
      this.handleBreakdownRowClicked(item, this.handleBreakdownReset, this.handleBreakdownSelect, this.filteredItems);
    },
    getImageChannels(list) {
      let result_list = [];
      list?.forEach(item => {
        result_list.push({
          redirect_link: `https://${item?.amazon_link}`,
          sales_channel: item?.sales_channel,
          flag: this.getCountryFlag(country_code_amz_sp_api_marketplace_ids_flipped[amz_sp_api_marketplace_ids_country_domains_flipped[item?.sales_channel?.toLowerCase()]])
        });
      });
      return result_list;
    },
    getSellerNameFromId(seller_id) {
      return this.accounts?.filter(item => item.account_id === seller_id)[0]?.account_name;
    },
    getTargetingTypeKey(value) {
      const targetingTypeMap = {
        "Non-Branded": TARGETING_TYPE_TYPES.NON_BRANDED_KWS,
        Branded: TARGETING_TYPE_TYPES.BRANDED,
        Competitor: TARGETING_TYPE_TYPES.COMPETITORS_PRODUCT,
        Discovery: TARGETING_TYPE_TYPES.DISCOVERY
      };
      return targetingTypeMap[value];
    },
    targetingTypeObject(keyValue) {
      return TARGETING_TYPE_SPLIT.find(({
        key
      }) => key === keyValue);
    }
  }
};